import styled from 'styled-components';

export const CarouselContainer = styled.div`
  width: 100%;
  position: relative;
  padding: 20px 0;
`;

export const CarouselHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-inline: 2rem;
`;

export const CarouselInfo = styled.div`
  color: #666;
  font-size: 14px;
`;

export const NavigationContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const NavButton = styled.button`
  background: #e75d0d;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    background: #c9a91ee6;
    transform: translateY(-1px);
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

export const CarouselWrapper = styled.div`
  overflow: hidden;
  border-radius: 8px;
  padding: 1rem;
`;

export const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.3s ease-in-out;
  transform: translateX(-${props => props.currentIndex * 100}%);
`;

export const CarouselSlide = styled.div`
  min-width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  padding: 0 10px;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ProductCard = styled.div`
  background: #f0f0f0;
  border: 1px solid #999;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  height: fit-content;
  
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }
`;

export const CardHeader = styled.div`
  border-bottom: 1px solid #5f5e5e;
  padding-bottom: 12px;
  margin-bottom: 16px;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
`;

export const Dot = styled.button`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: ${props => props.active ? '#e75d0d' : '#ddd'};
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: ${props => props.active ? '#c9a91ee6' : '#bbb'};
  }
`;